import React from 'react';
import { Box, Divider, List, ListItem, Typography, Grid } from '@material-ui/core';
import { PossibleQuestion, ResponseLabels } from '../../../interfaces/surveyScreen';
import RatingButtons from '../../../common/RatingButtons/ViewAllRatingButtons';
import LazyLoad from 'react-lazyload';
import { ViewAllStyles } from '../../../styles/ViewAllScreenStyles';

interface QuestionnaireSectionProps {
  questionnaire: PossibleQuestion[];
  labels: ResponseLabels[];
  isValidating: boolean;
  updateResponse: (data: string, qseq?: number | string) => Promise<string>;
}

const QuestionnaireSection = ({
  questionnaire,
  labels,
  isValidating,
  updateResponse,
}: QuestionnaireSectionProps): JSX.Element => {
  const classes = ViewAllStyles();

  const onAnswer = React.useCallback((data: string, qseq?: number | string): void => {
    updateResponse(data, qseq);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCompetencyName = (id: number): JSX.Element => {
    const prevCompetency = id === 0 ? '' : questionnaire[id - 1].competency;
    return (
      <>
        {questionnaire[id].competency &&
          questionnaire[id].competency !== '' &&
          prevCompetency !== questionnaire[id].competency && (
            <>
              {id !== 0 && <Divider aria-hidden="true" className={classes.divider} />}
              <Typography color="secondary" variant="h6" className={classes.competencyName}>
                {questionnaire[id].competency}
              </Typography>
            </>
          )}
      </>
    );
  };

  return (
    <List>
      {questionnaire &&
        questionnaire.map((ques: PossibleQuestion, index: number) => {
          return (
            <LazyLoad
              height={50}
              key={`${ques.itemID || ques.itemId}_${ques.scaleId}`}
              unmountIfInvisible={false}
              offset={500}
              once={true}>
              <ListItem key={`${ques.itemID || ques.itemId}_${ques.scaleId}`} className={classes.listStyle}>
                <Box className={classes.listItem}>
                  {getCompetencyName(index)}
                  <Divider aria-hidden="true" className={classes.divider} />
                  <Box className={classes.questionBlock}>
                    <Grid container>
                      <Grid item lg={5} sm={12}>
                        <div className={classes.question}>
                          <Typography aria-label={ques.questionText} role="heading" className={classes.font1rem}>
                            {ques.questionText}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid
                        item
                        lg={7}
                        sm={12}
                        className={classes.marginAuto}
                        key={`${ques.itemID || ques.itemId}_${ques.scaleId}`}>
                        <RatingButtons
                          qseq={index + 2}
                          labels={labels}
                          selectedResponse={ques.selectedResponse}
                          hasNoEvidence={ques.hasNoEvidence}
                          onAnswer={onAnswer}
                          isValidating={isValidating}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                  <Divider
                    aria-hidden="true"
                    className={`${index === questionnaire.length - 1 ? classes.finalDivider : classes.displayNone} ${
                      classes.divider
                    }`}
                  />
                </Box>
              </ListItem>
            </LazyLoad>
          );
        })}
    </List>
  );
};

export default QuestionnaireSection;
